import { Observable } from "rxjs";
import { BaseApiService } from "../../shared/utils/base-api-service";

export abstract class AccountManager extends BaseApiService {

    abstract deleteAccount(): Observable<boolean>;

}